import { render, staticRenderFns } from "./AgDetailMember.vue?vue&type=template&id=0dea9887&scoped=true"
import script from "./AgDetailMember.vue?vue&type=script&lang=js"
export * from "./AgDetailMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dea9887",
  null
  
)

export default component.exports